import { Icon, IconType } from '@assembly-js/design-system';
import { SvgIconProps } from '@mui/material';

// The slot menus reserve for a leading icon; `Icon` has no intrinsic size.
export const MENU_ICON_SIZE = 14;

export const MenuIcon = ({ icon }: { icon: IconType }) => (
  <Icon icon={icon} width={MENU_ICON_SIZE} height={MENU_ICON_SIZE} />
);

export const createMenuIcon = (icon: IconType) => () => (
  <MenuIcon icon={icon} />
);

// Drop-in for the MUI `SvgIcon` components these replace, which sized at 1em.
// Size goes in the width/height attributes rather than inline `style` so a
// caller's className or style can still override it.
export const createEmIcon =
  (icon: IconType) =>
  ({ className, style }: SvgIconProps) => (
    <Icon
      icon={icon}
      width="1em"
      height="1em"
      className={className}
      style={style}
    />
  );
